export default {"src":"/_next/static/media/quickbooks-icon.0188cf47.svg","height":18,"width":18};